/* eslint-disable @typescript-eslint/no-unused-vars */
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useController, UseControllerProps } from 'react-hook-form';
import classNames from 'classnames';

import { ButtonText } from '../../typography/typography';

const ControlledSwitchStyles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  .cookie-item-button {
    cursor: pointer;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 46px;
    padding: 12px 24px;
    background: #b0b3b9;
    color: white;
    text-align: center;
    border-radius: 6px;
    border: none;
    &.allow {
      background: #13b966;
    }
    &.reject {
      background: #ea3e4f;
    }
  }
`;

interface IControledSwitchProps {
  controllerProps: UseControllerProps<any>;
}
const ControlledSwitch: React.FC<IControledSwitchProps> = ({ controllerProps }) => {
  const { name, control, defaultValue, rules } = controllerProps;
  const {
    field: { ref, ...inputProps },
    fieldState: { invalid, isTouched, isDirty },
    formState: { touchedFields, dirtyFields },
  } = useController({
    name,
    control,
    defaultValue,
    rules,
  });
  const { t } = useTranslation(['common']);
  return (
    <ControlledSwitchStyles>
      <button
        className={classNames('cookie-item-button', {
          allow: inputProps.value === true,
        })}
        onClick={() => {
          inputProps.onChange(true);
        }}
      >
        <ButtonText>{t('common:buttons.accept')}</ButtonText>
      </button>
      <button
        className={classNames('cookie-item-button', {
          reject: inputProps.value === false,
        })}
        onClick={() => {
          inputProps.onChange(false);
        }}
      >
        <ButtonText>{t('common:buttons.reject')}</ButtonText>
      </button>
    </ControlledSwitchStyles>
  );
};

export default ControlledSwitch;
